import React, { useState, useEffect } from "react";
import RelatedPostsSkeleton from "./RelatedPostsSkeleton";

function RelatedPosts({ category, currentParama }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month}, ${year}`;
  };

  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content.split(" ").length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  useEffect(() => {
    const timestamp = new Date().getTime();
    fetch(`https://www.pixelliongroup.com/seotic/getBlogs.php?_=${timestamp}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch blogs");
        }
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          const filtered = data.filter(
            (post) => post.category === category && post.parama !== currentParama
          );
          setPosts(filtered.slice(0, 3));
        } else {
          throw new Error("Unexpected data format");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching related posts:", err);
        setError(err);
        setLoading(false);
      });
  }, [category, currentParama]);

  if (loading) {
   return <RelatedPostsSkeleton />;
     }

  if (error || posts.length === 0) {
    return null;
  }

  return (
    <div className="bg-slate-100 py-12">
      <div className="container mx-auto">
        <h3 className="text-2xl mb-8 px-5 md:px-0">Keep Reading</h3>
        <div className="grid gap-5 md:grid-cols-3 mx-5 md:mx-0">
          {posts.map((post) => (
            <a
                          href={`/blog/${post.parama}`}
              className="bg-white rounded overflow-hidden border border-slate-200"
            >
              <img
                loading="lazy"
                className="w-full object-cover"
                src={post.image}
                alt={post.title}
              />
              <div className="px-10 py-5">
                <p className="text-slate-400 text-sm mb-5">
                  {formatDate(post.date)} in {post.category} • {calculateReadingTime(post.content)} min read
                </p>
                <h4 className="text-xl font-medium mb-2">{post.title}</h4>
                <p className="text-slate-500 text-sm mb-4">{post.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RelatedPosts;